//TourneyBountyCreditHandler.js

import Handler from "../Handler";

class TourneyBountyCreditHandler extends Handler {
  execute(message) {
    //added a check based on a crash scenario where tourney id key is not received in this game protocol
    let receivedData = message ? JSON.parse(message) : undefined;
    this.service.processTourneyBountyCreditDetails(receivedData);
  }
}
export default TourneyBountyCreditHandler;

// bountyCredit# {
// String event = "bounty-credit";
// String playerName;
// double bountyAmount; // (the amount which the eliminator will get from knocking out the players)
// String tourneyId;
// HashMap<String, Double> bustedOutPlayersMap; //contains the players which were knocked out by the eliminator
// }
